<script>
  export default {
    name: 'TripleMaxBlast',

    methods: {
      openSignUpDialog() {
        this.$store.dispatch('changeSignupDialogState', true);
      },
    },
  };
</script>

<template>
  <div class="page-background">
    <div class="container">
      <h1>
        SIGN UP TODAY AND GET
        <span class="white--text">$5 FREE*</span>
      </h1>
      <a class="banner position-relative" @click="openSignUpDialog">
        <v-btn class="border-doubled join-button" color="gold" @click.stop.prevent="openSignUpDialog">
          PLAY FOR FREE NOW
        </v-btn>
      </a>
      <div class="w-full new-players-text">*for new players only</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .join-button {
    position: absolute;
    top: 85%;
    left: 48%;
    transform: translateX(-50%) translateY(-50%);
  }

  .page-background {
    display: flex;
    justify-content: center;
    width: 100%;
    height: 100%;
    background-image: url('/images/backgrounds/purple-star.webp');
    background-size: cover;
  }

  .container {
    padding-top: 55px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 80%;
    color: white;

    container-name: tmb;
    container-type: inline-size;

    h1,
    h2 {
      font-size: 72px;
      color: white;
      text-align: center;
    }

    h2 {
      margin-bottom: 20px;
    }

    .new-players-text {
      width: 100%;
      text-align: right;
      margin-top: 20px;
      max-width: 1200px;
      font-weight: 600;
      font-style: italic;
    }

    .banner {
      display: block;
      border-radius: 20px;
      width: 100%;
      max-width: 1200px;
      height: 500px;
      background-image: url('/images/banners/tmb.webp');
      background-position: top center;
    }

    @container tmb (width < 820 px) {
      .banner {
        background-image: url('/images/banners/tmb-mob.webp') !important;
        height: 100% !important;
        background-size: contain !important;
        min-height: 300px;
      }

      .new-players-text {
        text-align: center !important;
      }
    }

    @media (max-width: 960px) {
      width: 100%;

      h1 {
        margin-top: 55px;
      }

      h1,
      h2 {
        font-size: 36px;
      }
    }
  }
</style>
